import React from 'react';
import { CheckIcon, LeafIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { assurances, checkoutUrl, productBrand, productEdition } from '../data/offer';
export function FinalCta() {
  return <section className="border-t border-primary/20 bg-surface/40 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-58" data-mp="19g0d3ipnhwkf">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-59" data-mp="15cklj0sfumel">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-60" data-mp="1jcvce3tr00zr">
          <span className="inline-flex items-center gap-2" data-id="element-61" data-mp="1ed8xlpy9ucou">
            <LeafIcon className="h-8 w-8 shrink-0 text-primary drop-shadow-glow" aria-hidden="true" data-id="element-62" data-mp="1t2onl3pzae3h" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-accent sm:text-2xl" data-id="element-63" data-mp="1o4wkddjvv5jz">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-64" data-mp="1x51rdml601xm">
          Creata per i docenti della scuola secondaria che insegnano ambiente, risorse e sostenibilità.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-65" data-mp="s4fog7xgmj8d">
          Ottieni ora l&apos;Edizione Docenti
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-66" data-mp="122vcg216xcdn">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-67" data-mp="1658h0n47b48u">
              <CheckIcon className="h-4 w-4 text-primary drop-shadow-glow" aria-hidden="true" data-id="element-68" data-mp="1b39zp6xpt1js" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}